import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';
import './index.css';
import { useThemeStore } from './store/themeStore';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { TooltipProvider } from './components/ui/Tooltip';
import { initSentry } from './lib/sentry';
import { initErrorCapture } from './lib/errorCapture';
import ErrorBoundary from './components/ErrorBoundary';

// Initialize Sentry first (optional; when VITE_SENTRY_DSN is set)
initSentry();
// Initialize error capture before rendering
initErrorCapture();

// Initialize theme before rendering
useThemeStore.getState().initTheme();

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <TooltipProvider>
            <UnsavedChangesProvider>
              <SidebarProvider>
                <App />
              </SidebarProvider>
            </UnsavedChangesProvider>
          </TooltipProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

